module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAJBJREFUWEdjZBhgwDjA9jOMOmDohoDE8vcODCzM9eA09Odv44tIwQPkpCeyQwDsAGbm/WBL//51HHkOICe4sekhOQokVn+CBDsyoGcakFj16T+GA+iZBgbcATDfj+aC0RAYDYHREBgNgZEXAig+JtQYIKF2JLo9MDgcAGuEEgoBEhooRIcAITvJlR91wGgIAAAuGpMhh7EnowAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/xinxiactive.png
// module id = KtkF
// module chunks = 1